import ClipList from 'show-page/components/clip-list';
import styles from './styles.less';
import { observer } from 'mobx-react';


function OnlineExclusives(props) {
    return (
        <div className={ cx(styles.root, props.className) }>
            <header className={ styles.header }>
                <h3 className={ styles.title }>{ props.title }</h3>
            </header>
            <ClipList
                clips={ props.clips }
                highlightColor={ props.highlightColor }
                onVideoSelect={ props.onVideoSelect }
                rolloverTextColor={ props.rolloverTextColor }
                selectedVideoId={ props.selectedVideoId }
            />
        </div>
    );
}

OnlineExclusives.propTypes = {
    clips: React.PropTypes.object.isRequired,
    highlightColor: React.PropTypes.string.isRequired,
    onVideoSelect: React.PropTypes.func.isRequired,
    rolloverTextColor: React.PropTypes.string.isRequired,
    selectedVideoId: React.PropTypes.string,
    title: React.PropTypes.string.isRequired
};

OnlineExclusives.defaultProps = {
    title: 'Online Exclusives'
};


export default observer(OnlineExclusives);



/** WEBPACK FOOTER **
 ** ./src/show-page/components/online-exclusives/index.js
 **/